import(/* webpackMode: "eager" */ "/usr/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/usr/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/usr/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/usr/app/src/app/services/ki-governance-agentic-bi/components/KiGovernanceClient.tsx");
;
import(/* webpackMode: "eager" */ "/usr/app/src/components/features/guide/guide-read-next.css");
;
import(/* webpackMode: "eager" */ "/usr/app/src/assets/styles/pages.scss");
